// extracted by mini-css-extract-plugin
export var documentation = "_lr-1";
export var menu = "_lr-0";